import RequestContainer from 'components/containers/request.container';
import SubpageContainer from 'components/containers/subpage.container';
import FormInput from 'components/forms/form-input';
import FormSubmit from 'components/forms/form-submit';
import { Form } from 'react-final-form';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppSelector } from 'redux/hooks';
import { selectRequest } from 'request/request.slice';
import FormSelect from '../../../../components/forms/form-select';
import React from 'react';
import ChatbotSettingsShimmer from './chatbot-settings.shimmer';
import FormInputPassword from '../../../../components/forms/form-input-password';
import If from '../../../../components/conditionals/if.conditional';
import useFetch from '../../../../hooks/useFetch';
import { addChatbotSettings, getChatbotSettingDetails, updateChatbotSettings } from './chatbot-settings.thunks';
import FormElement from '../../../../components/forms/form-element';
import FormCheckboxSingle from '../../../../components/forms/form-checkbox-single';
import ChatbotSettingsSearchUser from './chatbot-settings.search-user';

function ChatbotSettingsForm() {
  const navigate = useNavigate();

  const { id } = useParams();
  const isCreating = id === 'new';
  let isFetching = false;
  let chatbotSetting = {
    name: '',
    url: '',
    environment: 'production',
    icon: 'bot',
    method: 'POST',
    path: '',
    authentication: 'None',
    token: '',
    isAll: false,
    users: [],
  };

  if (!isCreating) {
    ({ isFetching, data: chatbotSetting } = useFetch('chatbot-settings-details', () => getChatbotSettingDetails(id)));
  }

  const environment = [
    {
      value: 'production',
    },
    {
      value: 'test',
    },
    {
      value: 'development',
    },
  ];

  const method = [
    {
      value: 'POST',
    },
    {
      value: 'GET',
    },
    {
      value: 'PUT',
    },
    {
      value: 'PATCH',
    },
    {
      value: 'DELETE',
    },
    {
      value: 'HEAD',
    },
  ];

  const icon = [
    {
      value: 'Bot',
    },
    {
      value: 'Message',
    },
    {
      value: 'Brain',
    },
    {
      value: 'Zap',
    },
    {
      value: 'Sparkles',
    },
    {
      value: 'Globe',
    },
    {
      value: 'Server',
    },
    {
      value: 'CPU',
    },
    {
      value: 'Database',
    },
    {
      value: 'Cloud',
    },
  ];

  const authentication = [
    {
      value: 'None',
    },
    {
      value: 'Basic Auth',
    },
    {
      value: 'Header Auth',
    },
    {
      value: 'JWT',
    },
  ];

  const onSubmit = async (values) => {
    if (isCreating) {
      const res = await addChatbotSettings(values);
      if (res) {
        navigate('/dashboard/chatbot-settings');
      }
    } else {
      await updateChatbotSettings(id, values);
    }
  };
  return (
    <SubpageContainer title={isCreating ? 'Add New Chatbot Settings' : 'Update Chatbot Settings'}>
      <RequestContainer loading={isFetching} fallback={<ChatbotSettingsShimmer />}>
        <Form
          onSubmit={onSubmit}
          initialValues={chatbotSetting}
          render={({ handleSubmit, values }) => {
            const { isLoading } = useAppSelector(selectRequest);
            return (
              <form onSubmit={handleSubmit}>
                <div className="space-y-6 bg-white rounded-md">
                  <div className="grid sm:w-full xl:w-3/4 grid-cols-1 p-6 gap-4">
                    <div className=" grid grid-cols-1 gap-4">
                      <FormInput name="name" label="Name" />
                      <FormInput name="url" label="Url" />
                      <FormInput name="path" label="Path" />
                      <FormSelect
                        values={method}
                        name="method"
                        label="HTTP Method"
                        optionValue="value"
                        optionLabel="value"
                        initialValue={method[0]?.value}
                      />
                      <FormSelect
                        values={environment}
                        name="environment"
                        label="Environment"
                        optionValue="value"
                        optionLabel="value"
                        initialValue={environment[0]?.value}
                      />
                      <FormSelect
                        values={icon}
                        name="icon"
                        label="Icon"
                        optionValue="value"
                        optionLabel="value"
                        initialValue={icon[0]?.value}
                      />
                      <FormSelect
                        values={authentication}
                        name="authentication"
                        label="Authentication"
                        optionValue="value"
                        optionLabel="value"
                        initialValue={authentication[0]?.value}
                      />
                      <If show={values.authentication !== 'None'}>
                        <FormInputPassword name="token" label="Bearer Token" />
                      </If>
                      {/*<If show={!values.isAll}>*/}
                      <ChatbotSettingsSearchUser />
                      {/*</If>*/}
                      <FormElement label="For All">
                        <FormCheckboxSingle name="isAll" label="" />
                      </FormElement>
                    </div>
                    <div className="flex justify-end">
                      <FormSubmit label="Submit" showButtonOnly disabled={isLoading} />
                    </div>
                  </div>
                </div>
              </form>
            );
          }}
        />
      </RequestContainer>
    </SubpageContainer>
  );
}

export default ChatbotSettingsForm;
